/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { InteractivityChecker } from '@angular/cdk/a11y';

export function getTabbableElement(element: HTMLElement, interactivityChecker: InteractivityChecker): HTMLElement | null {
  const children: HTMLElement[] = Array.from(element.children) as HTMLElement[];

  for (const child of children) {
    if (interactivityChecker.isTabbable(child)) return child;

    const tabbableDescendant: HTMLElement = getTabbableElement(child, interactivityChecker);
    if (tabbableDescendant) return tabbableDescendant;
  }

  return null;
}

export function focusFirstInvalidField(formElement: HTMLElement): void {
  setTimeout(() => {
    const el = formElement.querySelector<HTMLElement>('input.ng-invalid, textarea.ng-invalid, select.ng-invalid');
    el?.focus();
  });
}

export const FocusUtil = { getTabbableElement, focusFirstInvalidField };
